"use client";

import { Button } from "@workspace/sc-ui/components/button";
import { toast } from "sonner";

export function showNotificationToast(options: {
  title: string;
  description?: string;
  openLabel: string;
  markReadLabel?: string;
  onOpen: () => void;
  onMarkRead?: () => void;
}) {
  const showMarkRead = Boolean(options.markReadLabel && options.onMarkRead);

  return toast.custom(
    (toastId) => (
      <div className="flex w-[min(100vw-2rem,22rem)] flex-col gap-3 rounded-lg border border-border bg-popover p-4 text-popover-foreground shadow-lg">
        <div className="space-y-1 pr-6">
          <p className="text-sm font-semibold leading-snug">{options.title}</p>
          {options.description ? (
            <p className="whitespace-pre-line text-sm text-muted-foreground">
              {options.description}
            </p>
          ) : null}
        </div>
        <div className="flex flex-wrap justify-end gap-2">
          {showMarkRead ? (
            <Button
              type="button"
              size="sm"
              variant="outline"
              onClick={() => {
                options.onMarkRead?.();
                toast.dismiss(toastId);
              }}
            >
              {options.markReadLabel}
            </Button>
          ) : null}
          <Button
            type="button"
            size="sm"
            onClick={() => {
              options.onOpen();
              toast.dismiss(toastId);
            }}
          >
            {options.openLabel}
          </Button>
        </div>
      </div>
    ),
    {
      duration: Number.POSITIVE_INFINITY,
      closeButton: true,
    },
  );
}
